import { Location } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbDateStruct, NgbModal, NgbModalRef, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { FileHandlerComponent } from '../../../components/file-handler/file-handler.component';
import { FileManager_PATH } from '../../../constants';
import { IncidentAccidentCommentModel, IncidentAccidentModel } from '../../../models/incidentAccidentModel';
import { AuthenticationService, IncidentAccidentServiceService, ModuleService, SettingsService, SiteService } from '../../../services';
import { DateHelper, DeviceHelper } from '../../../shared/helpers';
import { modalLarge } from '../../../shared/modules/dialogOptions';

@Component({
    selector: 'app-incident-accident-edit',
    templateUrl: './incident-accident-edit.component.html',
    styleUrls: ['./incident-accident-edit.component.scss', '../../../components/layout/layout.component.scss']
})
export class IncidentAccidentEditComponent implements OnInit {
    files: any[];
    previousFiles: any[];
    showSpinner: boolean = false;
    @ViewChild(FileHandlerComponent) filehanlder: FileHandlerComponent;
    model: IncidentAccidentModel = new IncidentAccidentModel();
    savingComment: boolean = false
    public IncidentAccidentId: any;
    module: any;
    moduleId: number = 30;
    sites: any = [];
    skadetypes: any = [];
    skadetypesLoading: boolean = false;
    Comment: string = '';
    fmActionOptions: string = "";
    DateComment: NgbDateStruct;
    TimeComment: NgbTimeStruct;
    GeneratingReport: boolean = false;
    deletingComment: boolean = false;
    loading: boolean = false;
    fmActionOptions2: string = "";
    fmActionOptions2Loading: boolean = true;
    timezone: any;
    fileLoading: boolean = false;
    filesUpload: any[];
    deleteId: any;
    currentId: any;
    processing = false;
    isOpen = false
    initialIsOpenValue: boolean;
    deletedCommentId: number
    openDeleteComment: boolean = false
    user: any
    filesToBeUploaded = []
    isMobile = false
    @ViewChild('form') form: FormGroup;

    constructor(private toastr: ToastsManager, public location: Location,
        private authenticationService: AuthenticationService,
        private modalService: NgbModal,
        private settingService: SettingsService,
        public activeModal: NgbActiveModal,
        private vRef: ViewContainerRef,
        private route: ActivatedRoute, private moduleService: ModuleService, private siteService: SiteService, private incidentAccidentSerice: IncidentAccidentServiceService) {
        this.toastr.setRootViewContainerRef(vRef)
    }
    formType: string = "Incident";
    role: any = {
        Name: '',
        Description: ''
    };
    ngOnInit() {
        this.isMobile = DeviceHelper.isMobile() ? true : false
        this.loading = true;
        this.previousFiles = []
        this.fmActionOptions2Loading = true;
        var now = new Date();

        this.model.Date = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
        this.model.Time = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };
        this.DateComment = this.model.Date;
        this.TimeComment = this.model.Time;

        // this.route.params.subscribe((params) => {         
        // if (params) {
        this.showSpinner = true;
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("timezone", this.user.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((responseD: any) => {
                if (responseD.Data != null) {
                    this.timezone = responseD.Data.Value;
                }
                this.incidentAccidentSerice.Get(this.IncidentAccidentId)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.model = response.Data;
                        if (this.model.AccidentType == 0) {
                            this.formType = "Incident";
                        }
                        else {
                            this.formType = "Accident";
                        }

                        //var timezone = params.context.componentParent.timezone;
                        var offset = moment.tz(this.timezone.slice(12)).format('Z');

                        var offsetNumber = +offset.split(':')[0];

                        var newDate = new Date(this.model.Date.year, this.model.Date.month - 1, this.model.Date.day, this.model.Time.hour, this.model.Time.minute, this.model.Time.second);
                        var newmomentDate = moment(newDate).add(offsetNumber, "hours");
                        this.model.Date.year = newmomentDate.year();
                        this.model.Date.month = newmomentDate.month() + 1;
                        this.model.Date.day = newmomentDate.date();

                        this.model.Time.hour = newmomentDate.hour();
                        this.model.Time.minute = newmomentDate.minute();
                        this.model.Time.second = newmomentDate.second();


                        this.loadSkadetypes();

                        var folder = "";
                        if (this.model.AccidentType == 0) {
                            folder = "Incident";
                        } else if (this.model.AccidentType == 1) {
                            folder = "Personskada";
                        } else if (this.model.AccidentType == 2) {
                            folder = "Fastighetsskada";
                        }
                        if (this.model.Status == 0) {
                            this.isOpen = true
                        }
                        this.initialIsOpenValue = this.isOpen
                        this.fmActionOptions = `&useSpecificSite=True&siteId=${this.model.SiteId}&useCustomRootFolder=True&customFolderName=${folder}_Data&rootFolderPrefix=${this.model.Id}`;
                        this.fmActionOptions2 = `&hideNavigation=true&useSpecificSite=True&siteId=${this.model.SiteId}&useCustomRootFolder=True&customFolderName=${folder}_Data&rootFolderPrefix=${this.model.Id}`;
                        this.fmActionOptions2Loading = false;
                        this.GetFiles();
                        this.loadRole();
                    });

                // this.model.SiteId = id;
                var user = JSON.parse(localStorage.getItem('currentUser'));

                this.loadSites(user.accountId);

            });


        // }
        //  });

    }
    modalReference: NgbModalRef;
    openLg(content, id) {

        this.deleteId = id;
        this.modalReference = this.modalService.open(content, {
            backdrop: 'static',
            keyboard: false,
            centered: true
        });
    }
    back() {
        this.filehanlder.back();
    }

    public checkAttachments() {
        if (this.filesToBeUploaded.length > 0) {
            if (confirm('You have attachment(s) to be uploaded. This will be gone once the modal is closed. Are you sure you want to continue?')) {
                this.activeModal.close()
            }
            return
        }
        this.activeModal.close()
    }

    deleteData(id: number) {
        if (this.openDeleteComment) {
            this.deleteComment(this.deleteId)
        }
        else {
            this.incidentAccidentSerice.deleteData(this.model)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.modalReference.close();
                    this.activeModal.close();
                    //this.DeleteData.emit({Data: ""});

                });
        }
    }

    setButtonRole(status: number) {
        if (status == 0) {
            if (this.role.Name == 'editor') {
                return true;
            } else if (this.role.Name == 'viewer') {
                return false;
            } else {
                return true;
            }
        } else {
            if (this.role.Name == 'editor') {
                return false;
            } else if (this.role.Name == 'viewer') {
                return false;
            } else {
                return true;
            }

        }
    }

    openFolderManager(settingsContent: string) {
        this.modalReference = this.modalService.open(settingsContent, modalLarge);
        this.modalReference.result.then((data) => {
            this.ngOnInit();
        }, (reason) => {
            this.ngOnInit();
        });
    }

    openAddComment(title: string) {
        this.modalReference = this.modalService.open(title, modalLarge);
    }

    saveComment() {
        if (!DateHelper.isDateValid(this.DateComment)) {
            this.toastr.error("Please check the date.", "Invalid date");
            return;
        }
        this.savingComment = true;
        var commentModel = new IncidentAccidentCommentModel();
        commentModel.Comment = this.Comment;
        commentModel.DateModel = this.DateComment;
        commentModel.TimeModel = this.TimeComment;
        commentModel.IncidentAccidentId = this.model.Id;

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        commentModel.Name = currentUser.displayName;

        this.incidentAccidentSerice.AddComment(commentModel)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                if (response.Success) {
                    this.savingComment = false;
                    this.Comment = "";
                    var now = new Date();
                    this.DateComment = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
                    this.TimeComment = <NgbTimeStruct>{ hour: now.getHours(), minute: now.getMinutes(), second: now.getSeconds() };

                    if (this.model.Comments == null) {
                        this.model.Comments = []
                    }
                    this.model.Comments = response.Data

                    this.toastr.success(response.Message, "Success");

                    this.modalReference.close();
                }
                else {
                    this.savingComment = false;
                    this.toastr.error(response.Message, "Error");
                }

            });
    }

    loadRole() {

        var moduleId = 30;
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.authenticationService.getRole(currentUser.id, moduleId, this.model.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.role = response.Data;
                this.showSpinner = false;
            });

    }

    saveChanges() {

        if (this.Comment == '') {
            if (this.form.invalid) {
                this.toastr.error("All required fields has not been filled or date is invalid", "Error");
                return;
            }
            this.processing = true;
            this.model.Status = this.booleanToInt(this.isOpen)
            this.model.ChangedBy = JSON.parse(localStorage.getItem("currentUser")).displayName
            this.incidentAccidentSerice.saveIncidentAccident(this.model)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    if (this.initialIsOpenValue != this.isOpen) {
                        this.saveStatus()
                    }
                    else {
                        if (this.filesToBeUploaded.length > 0) {
                            var events = []
                            this.filesToBeUploaded.forEach(file => {
                                events.push(file.Data)
                            });
                            this.filehanlder.uploadAsOne(events)
                            return
                        }
                        this.processing = false;
                    }
                });
        }
        else {

            this.toastr.warning("You have a pending comment that has not been added. To post the comment please click the comment button,", "Warning");
        }

    }

    saveStatus() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.model.Name = currentUser.displayName;
        this.model.Status = this.booleanToInt(this.isOpen)
        this.incidentAccidentSerice.toggleClose(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                if (this.filesToBeUploaded.length > 0) {
                    var events = []
                    this.filesToBeUploaded.forEach(file => {
                        events.push(file.Data)
                    });
                    this.filehanlder.uploadAsOne(events)
                    return
                }
                this.processing = false;
                // this.location.back();
            });
    };

    loadSites(accountId: number) {
        var user = JSON.parse(localStorage.getItem('currentUser'));

        this.moduleService.getModuleByTitle("Incident Accident")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((resp: any) => {

                this.module = resp.Data;

                this.siteService.getByAccountIdAndUserId(accountId, user.id, this.module.Id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.sites = response.Data;

                        if (this.model.SiteId == null || this.model.SiteId == 0) {

                            if (this.sites == undefined || this.sites.length == 0) {
                                return;
                            }

                            if (this.sites.filter(x => x.Id == this.model.SiteId).length <= 0) {

                                this.model.SiteId = this.sites[0].Id;

                            }
                        }

                    });
            });

    }

    deleteComment(id: number) {
        this.modalReference.close();

        this.deletedCommentId = id
        this.deletingComment = true;
        this.incidentAccidentSerice.DeleteComment(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.deletingComment = false
                this.model.Comments = this.model.Comments.filter(x => x.Id != id)
            });
    }

    loadSkadetypes() {

        if (this.model.AccidentType != undefined && this.model.AccidentType != 0) {
            this.skadetypesLoading = true;
            var user = JSON.parse(localStorage.getItem('currentUser'));
            this.incidentAccidentSerice.GetSkadetypes(this.model.AccidentType, user.accountId)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.skadetypes = response.Data;
                    this.skadetypesLoading = false;
                });
        }

    }

    public GetFiles() {
        //   this.fileLoading = true;
        //   let formData: FormData = new FormData();

        //   var user = JSON.parse(localStorage.getItem('currentUser'));
        //   formData.append("AccountId",user.accountId.toString());
        //   formData.append("IncidentAccidentId",this.model.Id.toString());
        //   formData.append("SiteId",this.model.SiteId.toString());

        //  // this.folderName = moment.utc(element).format("YYMMDD_HHmmss")

        // //   formData.append("ActionFolder",this.folderName + "_confirm");
        //   //let apiUrl = API_URL+"/Task/UploadFiles";

        //   $.ajax({
        //       type: "POST", 
        //       url:`${FileManager_PATH}/../AccidentIncidentFileHandler.ashx`,
        //        data: formData,
        //        processData: false,
        //        contentType: false,
        //       //data: `{ accountId: ${this.accountId}, moduleId: ${this.moduleId}, path: '${this.model['Id']}/${this.SiteId}/Confirms/${this.folderName}' }`,
        //       //contentType: 'application/json; charset=utf-8',
        //       dataType: 'json',
        //       success: (response) => {

        //           this.files = [];
        //           this.files = response;
        //           this.fileLoading = false;
        //           //$("#links").html("");
        //          // $('#links').append(response);

        //           //this.comment = "";
        //           //this.ngOnInit();
        //           //this.modalReference.close();
        //           //this.performingAction = false;
        //           //this.toastr.success("Action was performed successfully.","Success");
        //           //this.filesUpload = [];  
        //       },
        //       error: (err) => {

        //           this.fileLoading = false;
        //       }
        //   });
    }

    uploadFile(event) {

        this.filesUpload = [];
        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            //event.files[0]
            this.filesUpload.push(element)
        }

        var user = JSON.parse(localStorage.getItem('currentUser'));
        if (this.filesUpload.length >= 1) {

            let formData: FormData = new FormData();

            for (var i = 0; i < this.filesUpload.length; i++) {
                formData.append('uploadedFiles', this.filesUpload[i], this.filesUpload[i].name);
            }

            formData.append("AccountId", user.accountId.toString());
            formData.append("IncidentAccidentId", this.model.Id.toString());
            formData.append("SiteId", this.model.SiteId.toString());
            formData.append("UserId", user.id.toString());

            $.ajax({
                type: "POST",
                url: `${FileManager_PATH}/../AccidentIncidentUploadHandler.ashx`,
                data: formData,
                processData: false,
                contentType: false,
                //data: `{ accountId: ${this.accountId}, moduleId: ${this.moduleId}, path: '${this.model['Id']}/${this.SiteId}/Confirms/${this.folderName}' }`,
                //contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: (response) => {

                    this.files = [];
                    this.files = response;
                    this.fileLoading = false;
                },
                error: (err) => {

                    this.filesUpload = [];
                }
            });
        }

    }

    public openFile(data: any) {

        var element = document.createElement('a');
        var blob = this.base64toBlob(data.Base64, data.Mime); //new Blob([atob(data.Base64)], {type: data.Mime})
        var url = URL.createObjectURL(blob);
        element.setAttribute('href', url);
        element.setAttribute('download', data.Name);
        element.click();
    }


    base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }

    downloadPdf() {

        this.GeneratingReport = true;
        this.incidentAccidentSerice.DownloadReport(this.IncidentAccidentId, this.user.accountId, this.formType == "Accident")
            .catch((err: any) => {
                this.GeneratingReport = false;
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);
                this.GeneratingReport = false;
                // this.sending = false;
            });
    };

    isProcessing(value: boolean) {
        this.processing = value
    }

    booleanToInt(value: boolean): number {
        if (value) return 0
        return 1
    }

}



// WEBPACK FOOTER //
// ./src/app/incident-accident/components/incident-accident-edit/incident-accident-edit.component.ts